<template>
  <div>
    <div
      id="carouselExampleIndicators"
      class="carousel slide carousel-dark container-lg"
      data-bs-ride="carousel"
    >
      <div class="carousel-indicators">
        <button
          type="button"
          data-bs-target="#carouselExampleIndicators"
          data-bs-slide-to="0"
          class="active"
          aria-current="true"
          aria-label="Slide 1"
        ></button>
        <button
          type="button"
          data-bs-target="#carouselExampleIndicators"
          data-bs-slide-to="1"
          aria-label="Slide 2"
        ></button>
        <button
          type="button"
          data-bs-target="#carouselExampleIndicators"
          data-bs-slide-to="2"
          aria-label="Slide 3"
        ></button>
      </div>

      <div class="carousel-inner">
        <div class="carousel-item active">
          <img
            src="/images/B0W9Oes.jpg"
            class="d-block w-100"
            alt="advantage"
          />
        </div>
        <div class="carousel-item">
          <img
            src="/images/8mSihSR.jpg"
            class="d-block w-100"
            alt="solution"
          />
        </div>
        <div class="carousel-item">
          <img
            src="/images/Q0JibVh.jpg"
            class="d-block w-100"
            alt="chosen"
          />
        </div>
      </div>

      <button
        class="carousel-control-prev"
        type="button"
        data-bs-target="#carouselExampleIndicators"
        data-bs-slide="prev"
      >
        <span class="carousel-control-prev-icon" aria-hidden="true"></span>
        <span class="visually-hidden">Previous</span>
      </button>

      <button
        class="carousel-control-next"
        type="button"
        data-bs-target="#carouselExampleIndicators"
        data-bs-slide="next"
      >
        <span class="carousel-control-next-icon" aria-hidden="true"></span>
        <span class="visually-hidden">Next</span>
      </button>
    </div>
  </div>
</template>

<script setup>

</script>

<style scoped>
.carousel-indicators {
    position: absolute;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 2;
    display: flex
;
    justify-content: center;
    padding: -60px;
    margin-right: 15%;
    margin-bottom: 1rem;
    margin-left: 15%;
    margin: -39px;
}
</style>
